import URLPattern from 'url-pattern';
import { Identity } from '@equipmentshare/auth0-react';

export interface AuthState {
  loginStatus: AuthStateLoginStatus;
  authContext: Identity | null;
  isOwner: boolean;
  lastLoginStatus: AuthStateLoginStatus;
}

export enum AuthStateLoginStatus {
  NONE = 'NONE',
  LOADING = 'LOADING',
  AUTHENTICATED = 'AUTHENTICATED',
  NOT_AUTHENTICATED = 'NOT_AUTHENTICATED',
}

export interface AuthenticatedRouteObject {
  url: URLPattern;
  authTokenOptional?: boolean;
  isRequiredForSettingAuthState?: boolean;
}

export type AuthenticatedRoute = URLPattern | AuthenticatedRouteObject;
